import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { DataTable } from '../../components/Tables';
import PageHeader from '../shared/PageHeader';
import ConfirmDeleteModal from '../../components/common/ConfirmDeleteModal';
import { expensesApi, extractList } from '../../api/facades';

const ExpensesListPage: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [invStatus, setInvStatus] = useState('');
  const [deleteId, setDeleteId] = useState<number | null>(null);

  const { data: res, isLoading } = useQuery({
    queryKey: ['expenses'],
    queryFn: () => expensesApi.list(),
  });
  const rows = extractList(res);

  const deleteMu = useMutation({
    mutationFn: (id: number) => expensesApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expenses'] });
      setDeleteId(null);
      toast.success('Expense deleted.');
    },
    onError: (e: any) => toast.error(e?.message || 'Delete failed.'),
  });

  const columns = [
    { key: 'name', label: 'Expense' },
    { key: 'invoice_no', label: 'Invoice No.' },
    { key: 'total_amount', label: 'Total' },
    {
      key: 'inv_date',
      label: 'Invoice date',
      render: (r: any) => (r.inv_date ? String(r.inv_date).slice(0, 10) : '—'),
    },
  ];

  return (
    <div>
      <PageHeader hideTitle subtitle="Manage expenses. Vendor ID is required; Vendors API is not yet available." primaryAction={{ label: 'New', to: '/dashboard/expenses/new' }} />
      <div className="bg-white dark:bg-slate-800/50 rounded-2xl p-6">
        <div className="mb-4 flex flex-wrap gap-4" />
        <DataTable columns={columns} data={rows} loading={isLoading} emptyMessage="No expenses." onRowClick={(id) => navigate(`/dashboard/expenses/${id}`)} onEdit={(id) => navigate(`/dashboard/expenses/${id}/edit`)} onDelete={(id) => setDeleteId(Number(id))} />
      </div>
      <ConfirmDeleteModal open={deleteId != null} onClose={() => setDeleteId(null)} onConfirm={() => deleteId != null && deleteMu.mutate(deleteId)} title="Delete expense" message="Are you sure? This cannot be undone." loading={deleteMu.isPending} />
    </div>
  );
};

export default ExpensesListPage;
